import getValueReduxUtil from 'modules/redux/utils/get-value'
import { SECTIONS_NAME } from 'modules/sections/constants/index.cjs'

/**
 * Gets the url of the given category.
 * @param  {Instance} category
 * @param  {string} section
 * @returns {string}
 */
function getCategoryUrlModelUtil (category, section) {
  if (section === SECTIONS_NAME.HOME) {
    return ''
  }
  const name = getValueReduxUtil(category, 'name')
  if (section === SECTIONS_NAME.PAGES) {
    return `/${name}`
  }
  if (name === 'all') {
    return `/${section}`
  }
  return `/${section}/${name}`
}

export {
  getCategoryUrlModelUtil
}
